import { render, staticRenderFns } from "./IssuetrackingView.vue?vue&type=template&id=110f133b&"
import script from "./IssuetrackingView.vue?vue&type=script&lang=js&"
export * from "./IssuetrackingView.vue?vue&type=script&lang=js&"
import style0 from "./IssuetrackingView.vue?vue&type=style&index=0&id=110f133b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports